"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterComponent = void 0;
const core_1 = require("@rxdi/core");
const lit_html_1 = require("@rxdi/lit-html");
const injection_tokens_1 = require("./injection.tokens");
const outlet_1 = require("./outlet");
/**
 * @customElement router-outlet
 */
let RouterComponent = class RouterComponent extends lit_html_1.LitElement {
    constructor() {
        super(...arguments);
        this.id = "router-identifier";
    }
    OnUpdateFirst() {
        const router = new outlet_1.Outlet(this.shadowRoot.getElementById(this.id), core_1.Container.get(injection_tokens_1.RouterOptions));
        router.setRoutes(this.routes ? this.routes : core_1.Container.get(injection_tokens_1.Routes));
        core_1.Container.set('router-outlet', router);
        this.dispatchEvent(new CustomEvent('onRouterLoaded', { detail: router }));
    }
};
__decorate([
    (0, lit_html_1.property)(),
    __metadata("design:type", String)
], RouterComponent.prototype, "id", void 0);
__decorate([
    (0, lit_html_1.property)({ type: Array }),
    __metadata("design:type", Array)
], RouterComponent.prototype, "routes", void 0);
RouterComponent = __decorate([
    (0, lit_html_1.Component)({
        selector: "router-outlet",
        template() {
            return (0, lit_html_1.html) `
      <slot name="header"></slot>
      ${(0, lit_html_1.html) ` <main id="${this.id}"></main> `}
      <slot name="footer"></slot>
    `;
        },
    })
], RouterComponent);
exports.RouterComponent = RouterComponent;
